import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { otherColors } from '@tryhackme/thm-ui-components';

import { RoomStatus } from 'src/common/enums/rooms';

export const StyledSectionContainer = styled.section`
  width: 100%;
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.1rem;
`;

export const StyledFormToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledMutltipleFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const StyledSelectLabel = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const StyledRoomStatus = styled.div<{ $status: string | undefined }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.7rem 1.2rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  background-color: ${({ theme, $status }) => {
    if ($status === RoomStatus.SUBMITTED) {
      return theme.colors.info.lightest;
    }

    if ($status === RoomStatus.READY) {
      return theme.colors.success.lightest;
    }

    if ($status === RoomStatus.ACCEPTED) {
      return theme.colors.purple.lighter;
    }

    if ($status === RoomStatus.EVALUATING) {
      return theme.colors.warning.secondary;
    }

    if ($status === RoomStatus.REJECTED) {
      return otherColors.red2[20];
    }

    return theme.colors.background.grey;
  }};
`;

export const StyledRoomStatusEllipse = styled.div<{ $status: string | undefined }>`
  height: 0.8rem;
  width: 0.8rem;
  border-radius: ${({ theme }) => theme.radius.huge};
  background-color: ${({ theme, $status }) => {
    if ($status === RoomStatus.SUBMITTED) {
      return theme.colors.info.main;
    }

    if ($status === RoomStatus.READY) {
      return theme.colors.success.main;
    }

    if ($status === RoomStatus.ACCEPTED) {
      return theme.colors.purple.main;
    }

    if ($status === RoomStatus.EVALUATING) {
      return theme.colors.warning.main;
    }

    if ($status === RoomStatus.REJECTED) {
      return otherColors.red2[100];
    }

    return theme.colors.grey[600];
  }};
`;

export const StyledRoomStatusText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  text-transform: capitalize;
`;

export const StyledRoomStatusContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const StyledInfoIcon = styled(FontAwesomeIcon)`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-top: 1.7rem;
`;

export const StyledInfoText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  color: ${({ theme }) => theme.colors.text.lighter};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;

export const StyledMaximumTeamSize = styled.div`
  width: 14rem;
`;
